module.exports = __webpack_public_path__ + "static/media/insuranceSimplifiedLogo.3fa2f844.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/insuranceSimplifiedLogo.png
// module id = 987
// module chunks = 0